/**
 * Applies a stored value as the nuqs parser default so the first paint matches sticky state.
 */
export function seedParser<T>(parser: T, value: unknown): T {
  if (value === undefined) {
    return parser;
  }

  const withDefault = (parser as { withDefault?: (v: unknown) => T }).withDefault;
  if (typeof withDefault === 'function') {
    return withDefault.call(parser, value);
  }

  return parser;
}
